export const PAGE_PATH = '/specialisti';
